import _ from "lodash";
import React, { useContext, useEffect } from "react";
import { createUseStyles } from "react-jss";
import FullScreenLoader from "../../components/widgets/FullScreenLoader";
import jssVariables from "../../jss_setup";
import { CurrencyContext, StyleTypeContext } from "../../umbilical_tools";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ferriesErrorMsgs } from "../../errors";
import { useFerriesInitSearch } from "../../hooks/ferries";
import { validateFerrySearch } from "../../components/MainSearchForm/ferry/helpers";

function recreateFormData(decoded_data) {
  var data = {
    adults: decoded_data.adt,
    children: decoded_data.chd,
    seniors: decoded_data.snr,
    children_ages: decoded_data.ages,
    isRoundtrip: decoded_data.rTrp,
    origin: decoded_data.orgn,
    destination: decoded_data.dest,
    departDateTime: decoded_data.out,
    returnDateTime: decoded_data.ret,
  };

  return data;
}

const styles = createUseStyles({
  DeepFerrySearch: (props) => ({
    position: "absolute",
    background: "#FAFAFA",
    width: "100vw",
    height: "100vh",
    zIndex: 9999,
    ..._.get(props, "customStyles.DeepFerrySearch", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {},
});
const DeepFerrySearch = ({ encoded_data }) => {
  const { currency } = useContext(CurrencyContext);

  const [initSearch] = useFerriesInitSearch();
  const history = useHistory();

  const { type, brand, cStyler } = useContext(StyleTypeContext);
  const customStyles = cStyler({
    type,
    brand,
    objName: "DeepFerrySearch",
  });

  const classes = styles({ customStyles });

  const source_entity = useSelector((state) =>
    _.get(state.WebsiteMetadata, "metadata.source_entity")
  );

  function onError() {
    toast.warning(ferriesErrorMsgs.searchForm.init_search, { duration: 5000 });
    history.push("/");
  }

  var decoded_data = {};
  try {
    decoded_data = {
      ...recreateFormData(JSON.parse(window.atob(encoded_data))),
      currency,
    };
  } catch (error) {
    onError();
  }

  function onInitSearch(form) {
    initSearch(form);
  }

  async function onSearch(form) {
    await onInitSearch(form);
  }

  // Execute search
  useEffect(() => {
    if (!source_entity) {
      onError();
      return;
    }
    if (_.isEmpty(decoded_data)) {
      return;
    }

    if (
      validateFerrySearch({
        ...decoded_data,
        dates: [decoded_data.departDateTime, decoded_data.returnDateTime],
      })
    ) {
      onError();
      return;
    }

    onSearch(decoded_data);
  }, [encoded_data, source_entity]);

  return (
    <div className={classes.DeepFerrySearch}>
      <FullScreenLoader />
    </div>
  );
};
DeepFerrySearch.propTypes = {
  encoded_data: PropTypes.string.isRequired,
};
export default DeepFerrySearch;
